import instRequest from 'utils/instRequest'

// All audit reads go through the shared portal axios instance, so the base URL
// is inlined at build time and the auth token comes from the app's default
// header. Never read process.env here — in these webpack builds that is how
// bundles end up blank or silently pointing at DEV.

/**
 * Fetches one page of audit entries.
 * @param {object} params Filters plus optional cursor fields.
 * @returns {Promise<{items: object[], nextCursor: object|null}>}
 */
export const fetchAuditLogs = async (params) => {
  const { data } = await instRequest.get('/audit/logs', { params })
  return data?.data ?? { items: [], nextCursor: null }
}

/**
 * Fetches the action taxonomy for the filter dropdown.
 * @returns {Promise<string[]>}
 */
export const fetchAuditActions = async () => {
  const { data } = await instRequest.get('/audit/actions')
  return data?.data?.actions ?? []
}

/**
 * Downloads the filtered audit log as a spreadsheet.
 * @param {object} params Same filters as fetchAuditLogs, without pagination.
 * @returns {Promise<{blob: Blob, filename: string, isTruncated: boolean, rowCount: number}>}
 */
export const exportAuditLogs = async (params) => {
  const response = await instRequest.get('/audit/logs/export', {
    params,
    responseType: 'blob',
  })

  const disposition = response.headers['content-disposition'] || ''
  const match = disposition.match(/filename="?([^"]+)"?/)

  return {
    blob: response.data,
    filename: match ? match[1] : 'audit-log.xlsx',
    isTruncated: response.headers['x-audit-truncated'] === 'true',
    rowCount: Number(response.headers['x-audit-row-count'] || 0),
  }
}
